import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface ExcelDownloadRequest {
    order_status: number[];
    payment_status: number[];
    branch_type: number[];
    delivery_name: string[];
    customer_idx: string[];
    customer_branch_idx: string[];
    start_date: string | undefined;
    start_date_time: string;
    end_date: string | undefined;
    end_date_time: string;
    order_idx: number[];
}

export const usePostOrderExcelDownload = (successCallback?: () => void, errorCallback?: (error: any) => void) => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation({
        mutationFn: async (excelData: ExcelDownloadRequest) => {
            const response = await axios.post(enum_api_uri.post_order_excel_download, excelData, {
                headers: { Authorization: `Bearer ${accessToken}` },
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            link.setAttribute("download", "주문판매내역.xlsx");

            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        },
        onSuccess: () => {
            successCallback?.();
        },
        onError: error => {
            errorCallback?.(error);
        },
    });
};
